import React, { ReactElement } from 'react';
import { Link, graphql, useStaticQuery } from 'gatsby';
import * as styles from '../styles/navbar.module.css';

export default function Navbar(): ReactElement {
  const data = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  const { title } = data.site.siteMetadata;
  return (
    <nav>
      <h1>{title}</h1>
      <div className="links">
        <Link className={styles.link} to="/">
          Home
        </Link>
        <Link className={styles.link} to="/about">
          About
        </Link>
        <Link className={styles.link} to="/projects">
          Portfolio Projects
        </Link>
      </div>
    </nav>
  );
}
